(() => {
  if (customElements.get('sunpura-product-faq')) return;
  customElements.define('sunpura-product-faq', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.animations = new Map();
      const settle = item => {
        this.animations.get(item)?.cancel();
        this.animations.delete(item);
        item.style.height = '';
        item.style.overflow = '';
        delete item.dataset.expanding;
      };
      this.addEventListener('click', event => {
        const summary = event.target.closest('summary.sp-faq__question');
        if (!summary || !this.contains(summary)) return;
        const item = summary.parentElement;
        event.preventDefault();
        const opening = item.dataset.expanding ? item.dataset.expanding !== 'true' : !item.open;
        const start = item.getBoundingClientRect().height;
        settle(item);
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate) {
          item.open = opening;
          summary.setAttribute('aria-expanded', String(opening));
          return;
        }
        item.open = true;
        const end = opening ? item.getBoundingClientRect().height : summary.getBoundingClientRect().height;
        item.style.overflow = 'hidden';
        item.dataset.expanding = String(opening);
        summary.setAttribute('aria-expanded', String(opening));
        const animation = item.animate([{height:start+'px'},{height:end+'px'}], {duration:220,easing:'cubic-bezier(.16,1,.3,1)'});
        this.animations.set(item, animation);
        animation.onfinish = () => {item.open = opening; settle(item);};
      }, options);
      this.addEventListener('toggle', event => {
        if (event.target.matches?.('[data-faq-item]') && !event.target.open) settle(event.target);
      }, {...options,capture:true});
      const reveal = (item, focus) => {
        if (!item || !this.contains(item) || !item.matches('[data-faq-item]')) return;
        settle(item);
        item.open = true;
        if (focus) item.querySelector('summary')?.focus({ preventScroll: true });
        item.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      };
      const revealHash = () => {
        let id;
        try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        reveal(document.getElementById(id), true);
      };
      window.addEventListener('hashchange', revealHash, options);
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId !== this.dataset.sectionId && !this.contains(event.target)) return;
        const item = [...this.querySelectorAll('[data-faq-item]')].find(el => el.dataset.blockId === event.detail?.blockId);
        reveal(item, false);
      }, options);
      revealHash();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.animations?.forEach(animation => animation.cancel());
      this.querySelectorAll("[data-faq-item]").forEach(item => {item.style.height = ""; item.style.overflow = ""; delete item.dataset.expanding;});
    }
  });
})();

